import { createRouter, createWebHistory } from 'vue-router';
import scrollBehavior from './scrolling';
import Routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior,
  routes: Routes,
});

export default router;
